"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddAndEditPrimaryAssetGalleryModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const AssetLibrary_1 = require("@src/components/modules/AssetLibrary");
const react_1 = __importDefault(require("react"));
const useAppMutation_1 = require("@src/hooks/useAppMutation");
const antd_1 = require("antd");
const Api = __importStar(require("@src/api"));
const react_intl_1 = require("react-intl");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const styled_components_1 = require("styled-components");
const AddAndEditPrimaryAssetGalleryModal = ({ isPrimaryAssetGalleryModalOpen, setIsPrimaryAssetGalleryModalOpen, setPrimaryAssetGalleryToEdit, assetIdToPreSelect, gallery, }) => {
    const assetGalleryRef = react_1.default.useRef(null);
    const intl = (0, react_intl_1.useIntl)();
    const theme = (0, styled_components_1.useTheme)();
    const { invalidateSSRContext } = (0, useSSRFetch_1.useSSRFetchClient)();
    const { mutateAsync: createCompanyPrimaryAssetGallery } = (0, useAppMutation_1.useAppMutation)(Api.CompanyAssetGallery.createCompanyAssetGallery, {
        onSuccess: () => {
            showSuccessNotification();
        },
    });
    const { mutateAsync: updateCompanyPrimaryAssetGallery } = (0, useAppMutation_1.useAppMutation)(Api.CompanyAssetGallery.updateCompanyAssetGallery, {
        onSuccess: () => {
            showSuccessNotification();
        },
        onError: err => {
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'general.error',
                }),
                description: intl.formatMessage({
                    id: 'general.something_went_wrong',
                }),
            });
        },
    });
    function showSuccessNotification() {
        antd_1.notification.success({
            message: intl.formatMessage({
                id: 'general.warning',
            }),
            description: intl.formatMessage({
                id: 'general.successfuly_saved',
            }),
        });
    }
    const submitModal = async () => {
        var _a;
        const selectedAssets = (_a = assetGalleryRef.current) === null || _a === void 0 ? void 0 : _a.getSelectedAssets();
        if (!selectedAssets) {
            antd_1.notification.warning({
                message: intl.formatMessage({
                    id: 'admin.company_premium_profile.no_file_selected',
                }),
                description: intl.formatMessage({
                    id: 'admin.company_premium_profile.choose_at_least_one_file_gallery',
                }),
            });
            return;
        }
        if (assetIdToPreSelect && gallery) {
            await updateCompanyPrimaryAssetGallery({ galleryId: gallery.id, assetIds: [selectedAssets[0].id] });
        }
        else {
            await createCompanyPrimaryAssetGallery({ assetIds: [selectedAssets[0].id], isPrimaryGallery: true });
        }
        invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.companyProfile.key);
        setPrimaryAssetGalleryToEdit(null);
        setIsPrimaryAssetGalleryModalOpen(false);
    };
    react_1.default.useEffect(() => {
        if (assetIdToPreSelect && assetGalleryRef.current) {
            assetGalleryRef.current.setSelectedAssetIds([assetIdToPreSelect]);
        }
    }, [gallery]);
    return ((0, jsx_runtime_1.jsx)(elements_1.Modal, { visible: isPrimaryAssetGalleryModalOpen || Boolean(gallery), onCancel: () => {
            setPrimaryAssetGalleryToEdit(null);
            setIsPrimaryAssetGalleryModalOpen(false);
        }, width: theme.modalWidth.largeModal, onOk: submitModal, forceRender: true, okText: intl.formatMessage({
            id: 'admin.company_premium_profile.confirm_primary_asset_modal',
        }), cancelText: intl.formatMessage({
            id: 'admin.company_premium_profile.close_primary_asset_modal',
        }), title: intl.formatMessage({
            id: 'admin.company_premium_profile.choose_photo_video',
        }), children: (0, jsx_runtime_1.jsx)(AssetLibrary_1.AssetLibrary, { ref: assetGalleryRef, areDocumentsDisabled: true, isInSelectMode: true, allowSingleAssetSelectionOnly: true }) }));
};
exports.AddAndEditPrimaryAssetGalleryModal = AddAndEditPrimaryAssetGalleryModal;
